import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const userInfo = uni.getStorageSync('userInfo');
const token = uni.getStorageSync('token');

const store = new Vuex.Store({
	
	state: {
		userInfo: userInfo || '',	  // 用户信息
		token: token || '',
	},
	mutations: {
		// 设置token
		setToken(state, val) {
			state.token = val
			uni.setStorageSync('token', val);
		},
		// 设置用户信息
		setUserInfo(state, val) {
			state.userInfo = val
			uni.setStorageSync('userInfo', val);
		},
	}
	
})

export default store;